module.exports = require("core-js-pure/stable/instance/some");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/some.js
// module id = 598
// module chunks = 0